var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.759 8.767l6.326-6.028-5.397-.13a.788.788 0 01-.766-.804.779.779 0 01.798-.761l7.288.176c.431.01.771.367.76.799l-.175 7.288a.779.779 0 11-1.56-.038l.13-5.397-6.325 6.027a.785.785 0 01-1.106-.027.785.785 0 01.027-1.105z",
    fill: "#58B847",
    stroke: "#58B847"
  })));
}
export default SvgArrowRight;